import React from 'react';
import PropTypes from 'prop-types';

import FormManager from "src/core/gd-form/common/form-manager";
import ReassignUserTasks from "./tasks/tasks";
import ReassignUserEvents from "./events/events";
import ReassignUserProjects from "./projects/projects";
import VScroll from "src/core/gd-components/scrolling/custom-v-scroll/v-scroll";
import ButtonSubmitDeprecated from "src/core/gd-form/common/btn-submit/btn-submit-ui5";
import ErrorBoundary from "../../../error-boundary";
import ModalV4 from "../../../../app/ui/modal/v4/v4";
import ModalV4HeaderWhite from "../../../../app/ui/modal/v4/header-white/v4-header-white";
import Form from "../../../gd-form/form/form-modal-new/form-modal-new";

export default class ModalReassignProjectItems extends ModalV4 {

    static propTypes = {
        type: PropTypes.oneOf(['delete', 'access']),
        projectId: PropTypes.string,
        userId: PropTypes.string,
        reassignItems: PropTypes.object,

        callback: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.canSubmit = false;
        this.tasks =       _.uniqBy(this.props.params.reassignItems.taskAssignments, task=>task.id);
        this.events =      _.uniqBy(this.props.params.reassignItems.eventAssignments, event=>event.id);
        this.projects =    _.uniqBy(this.props.params.reassignItems.projectOwner, project=>project.id);

        const initFormData = {
            tasksReassignTo: null,
            eventsReassignTo: null,
            projectsReassignTo: null,
        };

        const formStructure = {
            isFormChanged: true,
            fields: {
                tasksReassignTo:    {type: 'select',    isRequired: this.tasks.length > 0,      label: "Tasks Assignee",},
                eventsReassignTo:   {type: 'select',    isRequired: this.events.length > 0,     label: "Events Assignee"},
                projectsReassignTo: {type: 'select',    isRequired: this.projects.length > 0,   label: "Project owner"},
            },
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure,initFormData);
    }

    onSubmit = (result) => {
        this.props.params.callback(result);
    }

    getInfo() {
        let res;

        const project = gd.session.projects.get(this.props.params.projectId);
        const user = gd.session.users.get(this.props.params.userId);

        switch (this.props.params.type) {
            case 'delete':
                // modal-info ui5-txt-default
                res = (
                    <div className="ui5-plate plate-error">
                        <p>You are about to delete <b>{user.name}</b> from <b>{project.name}</b> project.</p>
                        <p className="m-t-10">
                            This user has active assignments that must be updated before they can be removed.
                        </p>
                    </div>
                );
                break;
            case 'access':
                res = (
                    <div className="ui5-plate plate-error">
                        <p>You are about to set the read-only access level for <b>{user.name}</b> in <b>{project.name}</b> project.</p>
                        <p className="m-t-10">Please re-assign active tasks/events/projects if applicable and click reassign button.</p>
                    </div>
                );
                break;
        }
        return res;
    }

    render() {

        let submitLabel = '';
        switch (this.props.params.type) {
            case 'delete':
                submitLabel = 'Reassign & Delete';
                break;
            case 'access':
                submitLabel = 'Reassign & Update';
                break;
        }

        return (
            <div className="v4-container placement-middle" onClick={this.stopPropagation}>

                <ModalV4HeaderWhite height={60} title={this.props.params.title}/>

                <ErrorBoundary>
                <VScroll className="main-scroll" containerClass="main-container">

                    {this.getInfo()}
                    <ErrorBoundary>
                        <Form form={this.form} submitButton={false}>
                        <ReassignUserTasks form={this.form} tasks={this.tasks} projectId={this.props.params.projectId} userId={this.props.params.userId}/>
                        <ReassignUserEvents form={this.form} events={this.events} projectId={this.props.params.projectId} userId={this.props.params.userId}/>
                        <ReassignUserProjects form={this.form} projects={this.projects} projectId={this.props.params.projectId} userId={this.props.params.userId}/>
                        </Form>
                    </ErrorBoundary>
                </VScroll>

                <div className="modal-submit">
                    <ButtonSubmitDeprecated form={this.form} label={submitLabel}/>
                </div>
                </ErrorBoundary>
            </div>
        )
    }
}